import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { periodParams } from "@/lib/reportsApi";
import { REPORTS } from "@/constants/testIds";
import ExportButtons from "@/components/reports/ExportButtons";

/** Reporte de consumo de inventario en el periodo elegido (por producto),
 * consolidando los movimientos ya registrados por el modulo de Inventario. */
export default function InventoryConsumptionTab({ period }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    if (period.period === "custom" && (!period.start || !period.end)) return;
    setLoading(true);
    api.get("/reports/inventory-consumption", { params: periodParams(period) })
      .then(({ data }) => setData(data))
      .catch((err) => toast({ title: "No se pudo cargar Consumo de inventario", description: formatApiErrorDetail(err.response?.data?.detail), variant: "destructive" }))
      .finally(() => setLoading(false));
  }, [period]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading || !data) return <p className="text-center text-muted-foreground py-12">Cargando consumo de inventario...</p>;

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <ExportButtons reportKey="inventory_consumption" period={period} />
      </div>
      <div className="bg-white border border-border rounded-xl p-5" data-testid={REPORTS.inventoryConsumptionTable}>
        <h3 className="text-sm font-medium text-foreground mb-3">Consumo por producto</h3>
        {data.by_product.length === 0 ? (
          <p className="text-sm text-muted-foreground py-6 text-center">Sin consumo registrado en este periodo.</p>
        ) : (
          <div className="space-y-2">
            {data.by_product.map((p) => (
              <div key={p.label} className="flex items-center justify-between text-sm py-1.5 border-b border-border/60 last:border-0">
                <span className="text-foreground">{p.label}</span>
                <span className="font-medium text-foreground">{p.quantity} unidades <span className="text-muted-foreground">&middot; ${p.cost.toFixed(2)}</span></span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
